import { nameError } from '../../lib/names';
import { supabase } from '../../lib/supabase';

export type Profile = { id: string; username: string | null; created_at: string };

export async function getProfile(): Promise<Profile | null> {
  if (!supabase) return null;
  const { data: u } = await supabase.auth.getUser(); if (!u.user) return null;
  const { data } = await supabase.from('profiles').select('*').eq('id', u.user.id).maybeSingle();
  return (data as Profile) ?? null;
}

export const USERNAME_RE = /^[A-Za-z0-9_äöüÄÖÜß-]{3,24}$/;

/** Setzt den Nutzernamen. Gibt null zurück, wenn es geklappt hat, sonst eine Fehlermeldung. */
export async function setUsername(username: string): Promise<string | null> {
  if (!supabase) return 'Nicht verbunden.';
  const name = username.trim();
  if (!USERNAME_RE.test(name)) return 'Drei bis 24 Zeichen: Buchstaben, Ziffern, _ und -.';
  const bad = nameError(name, 'Dieser Nutzername'); if (bad) return bad;
  const { data: u } = await supabase.auth.getUser(); if (!u.user) return 'Nicht angemeldet.';
  const { error } = await supabase.from('profiles').update({ username: name }).eq('id', u.user.id);
  if (error) return error.code === '23505' ? 'Dieser Name ist schon vergeben.' : error.code === '23514' ? 'Dieser Nutzername ist nicht erlaubt. Bitte wähle einen anderen.' : error.message;
  return null;
}

export type MyRun = { id: string; party_name: string; legislatures: number; laws: number; score: number; difficulty: string; verified: boolean; created_at: string };
export async function myRuns(): Promise<MyRun[]> {
  if (!supabase) return [];
  const { data: u } = await supabase.auth.getUser(); if (!u.user) return [];
  const { data } = await supabase.from('runs').select('id,party_name,legislatures,laws,score,difficulty,verified,created_at').eq('user_id', u.user.id).order('created_at', { ascending: false }).limit(20);
  return (data as MyRun[]) ?? [];
}

/** Konto mit allen Daten in Supabase löschen (Funktion aus Migration 0005). */
export async function deleteAccount(): Promise<string | null> {
  if (!supabase) return 'Nicht verbunden.';
  const { error } = await supabase.rpc('delete_my_account');
  if (error) return /function .* does not exist|Could not find the function/i.test(error.message) ? 'Die Löschfunktion ist in der Datenbank noch nicht eingerichtet (Migration 0005).' : error.message;
  return null;
}
